import { STATUS_LABEL } from '@sc/shared/domain';
import type { HistoryEntry, Note } from '../admin/types';
import { formatBRL, formatDateTime } from '../lib/format';

export function HistoryList({ history }: { history: HistoryEntry[] }) {
  if (!history.length) return <p className="small">Nenhuma mudança de status ainda.</p>;
  return (
    <ul className="list-plain">
      {history.map((h) => {
        const to = h.toStatus ? STATUS_LABEL[h.toStatus] : '—';
        const valueChanged = h.fromValueCents !== h.toValueCents && h.toValueCents != null;
        return (
          <li key={h.id}>
            <strong>{h.fromStatus === h.toStatus && valueChanged ? 'Valor corrigido' : to}</strong>
            {valueChanged && <span className="mono"> · {formatBRL(h.toValueCents!)}</span>}
            <br />
            <span className="small">
              {h.byName ?? 'Sistema'}
              {h.byRole === 'admin' ? ' (admin)' : ''} · {formatDateTime(h.createdAt)}
            </span>
          </li>
        );
      })}
    </ul>
  );
}

export function NotesList({ notes }: { notes: Note[] }) {
  if (!notes.length) return null;
  return (
    <ul className="list-plain">
      {notes.map((n) => (
        <li key={n.id}>
          {n.body}
          <br />
          <span className="small">
            {n.byName ?? '—'}
            {n.byRole === 'admin' ? ' (admin)' : ''} · {formatDateTime(n.createdAt)}
          </span>
        </li>
      ))}
    </ul>
  );
}
